module.exports = __webpack_public_path__ + "static/9-bc71f68987ffb8b2ab64006375c79843.jpeg";